import { Check } from "lucide-react";
import { Reveal } from "./Reveal";
import { useContent } from "@/content/ContentContext";

export const About = () => {
  const content = useContent();
  const { about } = content;
  const paragraphs = about.paragraphs.filter(Boolean);
  const facts = about.facts.filter(Boolean);

  return (
    <section
      id="ueber-mich"
      data-testid="about-section"
      className="mx-auto max-w-7xl px-6 py-24 md:px-10 md:py-40"
    >
      <div className="grid grid-cols-1 gap-14 md:grid-cols-12 md:gap-10">
        <Reveal className="md:col-span-5">
          <div className="relative">
            <div className="overflow-hidden border border-foreground/10">
              <img
                src={about.portrait_url}
                alt="Der Kopf hinter Rundum auf der Baustelle"
                data-testid="about-portrait"
                className="aspect-[4/5] w-full object-cover transition-transform duration-700 ease-out hover:scale-[1.03]"
              />
            </div>
            <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.25em] text-muted-foreground">
              {about.caption}
            </p>
          </div>
        </Reveal>

        <div className="md:col-span-6 md:col-start-7">
          <Reveal>
            <p
              className="mb-4 font-mono text-xs uppercase tracking-[0.25em] text-primary"
              data-testid="about-chapter"
            >
              01 · Über mich
            </p>
            <h2
              className="font-heading text-4xl font-black tracking-tight text-foreground sm:text-5xl"
              data-testid="about-heading"
            >
              {about.heading}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-8 space-y-5 text-base leading-relaxed text-muted-foreground md:text-lg">
              {paragraphs.map((p, i) => (
                <p key={i} className={i === paragraphs.length - 1 ? "font-medium text-foreground" : ""}>
                  {p}
                </p>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <ul className="mt-10 space-y-3 border-t border-foreground/10 pt-8">
              {facts.map((f) => (
                <li
                  key={f}
                  className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.2em] text-foreground md:text-sm"
                >
                  <Check className="h-4 w-4 shrink-0 text-primary" />
                  {f}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
